module.exports = __webpack_public_path__ + "img/macurco-logo.f9f9d415.png";